// safeStorage: a drop-in localStorage replacement that survives:
//  - Browsers that block 3rd-party localStorage in iframes (Chrome CHIPS /
//    Safari ITP storage partitioning)
//  - Private / incognito modes where localStorage throws QuotaExceededError
//
// Priority: localStorage → sessionStorage → in-memory Map.
//
// Public API matches the subset we actually use: getItem, setItem, removeItem.

const memory = new Map();

const tryLS = () => {
  try {
    const k = "__meos_probe__";
    window.localStorage.setItem(k, "1");
    window.localStorage.removeItem(k);
    return window.localStorage;
  } catch (_e) {
    return null;
  }
};

const trySS = () => {
  try {
    const k = "__meos_probe__";
    window.sessionStorage.setItem(k, "1");
    window.sessionStorage.removeItem(k);
    return window.sessionStorage;
  } catch (_e) {
    return null;
  }
};

const ls = tryLS();
const ss = ls ? null : trySS();

export const safeStorage = {
  getItem(k) {
    if (ls) {
      try { return ls.getItem(k); } catch (_e) { /* fall through */ }
    }
    if (ss) {
      try { return ss.getItem(k); } catch (_e) { /* fall through */ }
    }
    return memory.has(k) ? memory.get(k) : null;
  },
  setItem(k, v) {
    if (ls) {
      try { ls.setItem(k, v); return; } catch (_e) { /* fall through */ }
    }
    if (ss) {
      try { ss.setItem(k, v); return; } catch (_e) { /* fall through */ }
    }
    memory.set(k, String(v));
  },
  removeItem(k) {
    if (ls) {
      try { ls.removeItem(k); } catch (_e) { /* ignore */ }
    }
    if (ss) {
      try { ss.removeItem(k); } catch (_e) { /* ignore */ }
    }
    memory.delete(k);
  },
};

export default safeStorage;
